const AGENT_PAGE_VIEW_EVENT = 'agent_page_view';
const AGENT_INTERACTION_EVENT = 'agent_interaction';

const isPrimitive = (value) => ['string', 'number', 'boolean'].includes(typeof value);

const sanitizeValue = (value) => {
  if (value === null || value === undefined) return undefined;
  if (isPrimitive(value)) return value;
  return String(value);
};

const sanitizeParams = (params = {}) => Object.entries(params).reduce((acc, [key, value]) => {
  const safeValue = sanitizeValue(value);
  if (safeValue !== undefined) {
    acc[key] = safeValue;
  }
  return acc;
}, {});

const getGtagInstance = (vm) => vm?.$gtag;

export const trackAgentEvent = (vm, eventName, params = {}) => {
  const gtag = getGtagInstance(vm);
  const eventParams = {
    ...sanitizeParams(params),
    transport_type: 'beacon',
  };

  if (gtag && typeof gtag.event === 'function') {
    gtag.event(eventName, eventParams);
    return;
  }

  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
  }
};

export const trackAgentPageView = (vm, route) => {
  if (!route || !route.name) return;
  trackAgentEvent(vm, AGENT_PAGE_VIEW_EVENT, {
    route_name: route.name,
    route_path: route.path,
  });
};

export const trackAgentInteraction = (vm, action, params = {}) => {
  trackAgentEvent(vm, AGENT_INTERACTION_EVENT, {
    interaction_type: action,
    route_name: vm?.$route?.name || 'unknown',
    ...params,
  });
};
